import styled from "styled-components/macro";

import {
  space,
  breakpoint,
  MAX_WIDTH,
  LEFT_CONTAINER_WIDTH,
  GRID_GAP_VERTICAL,
  GRID_GAP_HORIZONTAL,
  ContentWidth,
  colors,
} from "shared/styles/constants";

export const GridLayout = styled.div`
  display: grid;
  grid-gap: calc(${GRID_GAP_VERTICAL} / 2);
  grid-template-rows: auto auto auto auto auto auto;
  grid-template-columns: 100%;
  grid-template-areas:
    "nav"
    "prevnext"
    "side"
    "head"
    "main"
    "footer";

  ${breakpoint("m", "up")} {
    min-height: 100%;
    grid-gap: ${GRID_GAP_VERTICAL};
    grid-template-rows: auto auto 1fr auto;
    grid-template-columns: ${LEFT_CONTAINER_WIDTH}px calc(
        100% - ${LEFT_CONTAINER_WIDTH}px - ${GRID_GAP_HORIZONTAL}
      );
    grid-template-areas:
      "nav nav"
      "prevnext head"
      "side main"
      "footer footer";
  }
`;

export const Content = styled.div`
  margin: 0 auto;
  width: ${MAX_WIDTH};

  ${breakpoint("m", "up")} {
    margin: 0;
  }
`;

export const MainContent = styled.div`
  grid-area: main;

  max-width: ${ContentWidth.default};

  margin-bottom: ${space.xxl};

  ${breakpoint("l", "down")} {
    width: 100%;
    max-width: 100vw;
    margin: 0 auto;
  }
`;

interface CenterContentProps {
  width?: ContentWidth;
  verticalMargin?: keyof typeof space;
}

export const CenterContent = styled(Content)<CenterContentProps>`
  grid-area: side / nav / main;

  max-width: ${({ width }) => width || ContentWidth.default};

  margin: ${({ verticalMargin }) =>
    `${verticalMargin ? space[verticalMargin] : 0} auto !important`};
`;

interface FlexContainerProps {
  size?: keyof typeof space;
  align?: "flex-start" | "center" | "flex-end" | "stretch";
  justifyContent?:
    | "flex-start"
    | "center"
    | "flex-end"
    | "stretch"
    | "space-between";
  flexWrap?: "wrap" | "nowrap";
  gap?: keyof typeof space;
  lineHeight?: keyof typeof space;
}

export const FlexContainer = styled.div<FlexContainerProps>`
  display: flex;
  align-items: ${({ align = "center" }) => align};
  justify-content: ${({ justifyContent }) => justifyContent};

  flex-wrap: ${({ flexWrap = "wrap" }) => flexWrap};

  margin: -${({ size = "xxs" }) => space[size]};

  gap: ${({ gap }) => gap && space[gap]};

  line-height: ${({ lineHeight }) => lineHeight && space[lineHeight]};

  > * {
    margin: ${({ size = "xxs" }) => space[size]};
  }
`;

interface FlexItemProps {
  flex?: number | string;
}

export const FlexItem = styled.div<FlexItemProps>`
  flex: ${({ flex }) => flex && `${flex} !important`};
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${space.xs};

  ${breakpoint("s", "down")} {
    grid-template-columns: 1fr;
  }

  @media print {
    > div:nth-child(odd) *,
    > button:nth-child(odd) * {
      background-color: ${colors.grey6} !important;
    }

    > div:nth-child(even) *,
    > button:nth-child(odd) * {
      background-color: transparent;
    }

    padding-bottom: ${space.l};

    > button {
      width: 100%;
    }
  }
`;

export const HiddenMobileContainer = styled.div`
  ${breakpoint("l", "down")} {
    display: none;
  }
`;

export const HiddenDesktopContainer = styled.div`
  ${breakpoint("l", "up")} {
    display: none;
  }
`;

export const IconWithText = styled.div`
  > * {
    vertical-align: middle;
  }

  > * + * {
    padding-left: ${space.xs};
  }
`;
